<template>
  <ol class="steps">
    <!-- <li><router-link :to="{ name: 'home' }" v-bind:class="{ 'active' : currentStep == 'home' }">Get Started</router-link></li> -->
    <li><a href="/services/bottled-water-delivery">Get Started</a></li>
    <li><router-link :to="{ name: 'products' }" v-bind:class="{ 'active' : currentStep == 'products' }">Products</router-link></li>
    <li><router-link :to="{ name: 'order-summary' }" v-bind:class="{ 'active' : currentStep == 'order-summary' }">View Cart</router-link></li>
    <li>
      <router-link 
        :to="{ name: 'checkout' }" 
        v-bind:class="{ 'active' : currentStep == 'checkout' }" 
        v-bind:disabled="checkoutDisabled"
      >Checkout</router-link>
    </li>
  </ol>
</template>

<script>
import store from '../store.js'

export default {
  computed: {
    currentStep() {
      return store.state.currentStep
    },
    checkoutDisabled() {
      return store.getters.numCartItems <= 0
    }
  },
}
</script>
